<template>
    <div>
        <CartSidebar :open="sidebarOpen" @close="sidebarOpen = false" />
        <nav id="topnav" class="is-sticky bg-sky-900">
            <div class="container relative">
                <router-link to="/" class="logo !mx-2">
                    <div>
                        <img src="../../assets/images/logo-white.png" class="h-[40px] inline-block" alt="">
                    </div>
                </router-link>
                <div class="menu-extras mx-2 " data-collapse="isToggle" aria-controls="isToggle" aria-expanded="false"
                    @click="handler">
                    <div class="menu-item">
                        <a class="navbar-toggle" id="isToggle" :class="toggle === false ? '' : 'open'">
                            <div class="lines">
                                <span class="!bg-white"></span>
                                <span class="!bg-white"></span>
                                <span class="!bg-white"></span>
                            </div>
                        </a>
                    </div>
                </div>

                <!--Login button Start-->
                <ul class="buy-button list-none mb-0">
                    <li class="dropdown inline-block relative ps-0.5">
                        <button @click.prevent="sidebarOpen = !sidebarOpen"
                            class="group dropdown-toggle size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full bg-transparent hover:bg-white text-white hover:text-sky-900"
                            type="button">
                            <i data-feather="shopping-cart"
                                class="h-5 w-5 group-hover:h-4 group-hover:w-4 duration-100"></i>
                        </button>
                    </li>
                </ul>
                <!--Login button End-->

                <div id="navigation" :class="toggle === false ? 'none' : 'block'">
                    <!-- Navigation Menu-->
                    <ul class="navigation-menu ">

                        <li :class="activeMenu === '/coches-clasicos' ? 'active' : ''"><router-link
                                to="/coches-clasicos" class="sub-menu-item nav-link duration-500">Coches
                                Clásicos</router-link></li>

                        <li :class="activeMenu === '/sillas-de-paseo' ? 'active' : ''"><router-link
                                to="/sillas-de-paseo" class="sub-menu-item nav-link duration-500">Sillas de
                                paseo</router-link></li>

                        <li :class="activeMenu === '/coche-silla' ? 'active' : ''"><router-link
                                to="/coche-silla"
                                class="sub-menu-item nav-link duration-500">Coche-Silla</router-link>
                        </li>

                        <li :class="activeMenu === '/juguetes' ? 'active' : ''"><router-link to="/juguetes"
                                class="sub-menu-item nav-link duration-500">Juguetes</router-link>
                        </li>

                        <li :class="activeMenu === '/outlet' ? 'active' : ''"><router-link to="/outlet"
                                class="sub-menu-item nav-link duration-500">Outlet</router-link>
                        </li>
                    </ul><!--end navigation menu-->
                </div><!--end navigation-->
            </div><!--end container-->
        </nav><!--end header-->
        <!-- End Navbar -->

    </div>
</template>

<script>
import CartSidebar from '@/components/CartSidebar.vue'
import feather from 'feather-icons'
import { eventBus } from '@/eventBus.js'

export default {
    props: {},
    name: "navbarVue",
    components: {
        CartSidebar
    },
    data() {
        return {
            toggle: false,
            scroll: true,
            sections: document.querySelectorAll("section"),
            navLi: document.querySelectorAll("nav .container .navigation ul li"),
            sectionTop: null,
            id: 1,
            searchmenu: false,
            account: false,
            activeMenu: '',
            menu: true,
            menuOpen: '',
            sidebarOpen: false


        }
    },
    mounted() {

        feather.replace()

    },
    
    created() {
    window.addEventListener('scroll', this.handleScroll);
    this.activeMenu = window.location.pathname;
    window.addEventListener("click", this.close);

    // 🔥 OJO: Esto añade el listener global para abrir el carrito
    this.$watch(
        () => eventBus.openCart,
        (value) => {
            if (value === true) {
                this.sidebarOpen = true
                eventBus.openCart = false  // lo resetemos
            }
        }
    )
},

    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        handler: function () {
            this.toggle = !this.toggle;
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.searchmenu = false;
                this.cartmenu = false;
                this.account = false;

            }
        },
        submenu(item) {
            this.menu = !this.menu
            this.menuOpen = item
        },

        handleScroll() {
            const navbar = document.getElementById("topnav");
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }
        },
    },


}
</script>

<style lang="scss" scoped></style>